import React from 'react';
import { Translated } from 'utils/staticText';
import { ClippedTextStaticText } from './i18n';

interface ClippedTextProps {
  clippedLength: number;
  children: React.ReactNode;
  staticText: Translated<typeof ClippedTextStaticText>;
}

export const ClippedText: React.FC<ClippedTextProps> = ({
  clippedLength,
  children,
  staticText,
}) => {
  const [isClipped, setIsClipped] = React.useState(
    typeof children === 'string' ? children.length > clippedLength : false,
  );

  if (typeof children !== 'string') {
    return children;
  }

  return (
    <span>
      {isClipped ? `${children.slice(0, clippedLength)}... ` : children}
      {isClipped ? (
        <span
          role="button"
          tabIndex={0}
          className="underline text-link"
          onClick={(event) => {
            event.stopPropagation();
            setIsClipped(false);
          }}
        >
          {staticText.seeMore.toLocaleLowerCase()}
        </span>
      ) : null}
    </span>
  );
};
